module.exports = __webpack_public_path__ + "img/client2.85886648.jpg";